import React from "react";
import { ChipWrapper, ChipText, ChipVariant } from "./chip.styles";
import { Icon } from "design-system/components/icon/icon";
import { ColearnIconsId } from "design-system/foundation/icon-font/colearn-icons";

interface ChipProps {
  variant: ChipVariant;
  icon?: ColearnIconsId;
  label: string;
}

export const Chip: React.FC<ChipProps> = ({ variant, icon, label }) => {
  return (
    <ChipWrapper $variant={variant}>
      {icon && <Icon name={icon} />}
      <ChipText>{label}</ChipText>
    </ChipWrapper>
  );
};
